import { brandApi } from "../lib/axios";

export type EnterpriseRequestStatus = "NEW" | "CONTACTED" | "CLOSED";

export interface EnterprisePlanRequest {
  id: string;
  status: EnterpriseRequestStatus;
  contactName: string;
  email: string;
  createdAt: string;
  updatedAt: string;
}

export interface EnterprisePlanRequestInput {
  contactName: string;
  email: string;
  phone?: string;
  companyName?: string;
  monthlyRevenue?: string;
  message?: string;
}

export interface MyEnterpriseRequestResponse {
  request: EnterprisePlanRequest | null;
  hasOpenRequest: boolean;
}

export const enterprisePlanService = {
  /** Latest request for the logged-in store, used to show its status on the pricing cards */
  async getMyRequest(): Promise<MyEnterpriseRequestResponse> {
    const { data } = await brandApi.get("/enterprise-plan/requests/mine");
    return data;
  },

  /** Notifies the partnership inbox; resubmitting updates the store's open request */
  async submitRequest(
    input: EnterprisePlanRequestInput,
  ): Promise<{ request: EnterprisePlanRequest; isUpdate: boolean }> {
    const { data } = await brandApi.post("/enterprise-plan/requests", input);
    return data;
  },
};
